/**
 * ScopePill — visual badge for the three-tier provenance classification.
 * A2F-473/474: Used in the Scope column of every Review page table.
 */

import type { FindingTier } from '@/lib/findingClassification';

export const SCOPE_LABELS: Record<FindingTier, string> = {
  'new': 'This sub',
  'pre-existing': 'This sub + prior',
  'inherited': 'Prior',
};

const SCOPE_PILL_CLASSES: Record<FindingTier, string> = {
  'new': 'text-amber-700 bg-amber-50 border border-amber-200',
  'pre-existing': 'text-sky-700 bg-sky-50 border border-sky-200',
  'inherited': 'text-slate-500 bg-slate-100 border border-slate-200',
};

export function ScopePill({ tier }: { tier: FindingTier }) {
  return (
    <span
      className={`inline-block text-[11px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${SCOPE_PILL_CLASSES[tier]}`}
    >
      {SCOPE_LABELS[tier]}
    </span>
  );
}
